import React, { Component } from 'react';
import './HandHistory.css';
import ReplayHand from '../HandReplayer/ReplayHand.js';
import HandReplayer from '../HandReplayer/HandReplayer.js';
import { getCurrencySymbol, saveActivity } from "../../common/commonService";
import { DispatcherFunction } from 'mygame-components';
import i18next from 'i18next';
// const baseUrlImage = "////mygame-dev.mypartypokerlive.com";
const baseUrlImage = "";
import { connect } from "react-redux";
class HandCardMobile extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openHandRep: false,
      staredHand: this.props.hand.staredHand,
      isSelected: false
    }
  }
  handReplayerOpen =  () => {
    let gameType = this.props.hand.gameType==='Spin'?'spin':this.props.hand.gameType;
    if(window.messageToNative || (window.external && window.external.NativeDispatch)){
      DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
        "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
        `/PopUpHandReplayer/${gameType}/${this.props.hand.gameNo}/${localStorage.getItem("accountName")}/${this.props.hand.fullDateTime? this.props.hand.fullDateTime: this.props.hand.time}`,
        "location":"yes",
        "height":"720",
        "width":"1000",
        "scrollbars":"yes",
        "status":"yes"
  })
  saveActivity({
    hit_page : 'MyHands',
    hit_type : 'MyHandsGameReplay',
    hit_attribute1 : this.props.hand.gameType,
    hit_attribute2 : this.props.hand.gameNo,
    hit_attribute3 : this.props.hand.fullDateTime? this.props.hand.fullDateTime: this.props.hand.time,
    hit_attribute4 : '',
    hit_attribute5 : '',
      })
}
    else{
    this.setState({ openHandRep: true });
  }
  }
  toggleStaredHand = () => {
    this.setState({ staredHand: !this.state.staredHand }, () => {
      this.props.setStarFlagOfHnad(this.props.hand, this.state.staredHand)
    });
  }
  render() {
    let fullVersion = 0
    // console.log("navigator.appVersion", navigator.appVersion)
    if (navigator.appVersion.includes("Mac")) {
      if (navigator.appVersion.includes("Mobile")) {
        let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
        if (fullVersion > 12.10) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      } else {
        let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
        if (fullVersion > 10.13) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      }
    } else {
      fullVersion = 13;
    }
    let hand = { ...this.props.hand }
    let isSelected = false;
    this.props.selectedHandList.map(handObj => {
      if (handObj.gameNo === hand.gameNo && handObj.fullDateTime === hand.fullDateTime) {
        isSelected = true;
        if (isSelected !== this.state.isSelected) {
          this.setState({ isSelected })
        }
      }
    })
    return (
      <div>

        {this.state.openHandRep ? <div style={{
          top: 0,
          left: 0,
          zIndex: 20000,
          width: "100%",
          height: "100%",
          overflow: "auto",
          position: "fixed",
          backgroundColor: '#2c2c34'
        }}>
          <style>{"\
        .navbar-fixed-top{\
          z-index:0 !important;\
        }\
      "}</style>
          {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
            replayerScreen={'desktop'}
            gameTypeForTitle={hand.gameType}
            onClose={() => this.setState({ openHandRep: false })}
            loginStatus={true}
            gameNo={hand.gameNo}
            accountName={localStorage.getItem('accountName')}
            // playerDtlsList={this.state.playerDtlsList}
            // actionDtlsList={this.state.actionDtlsList}
            // defaultPlayersList={this.state.defaultPlayersList}
            // defaultActionList={this.state.defaultActionList}
            partitionDate={hand.fullDateTime}
          // fromDate={repoSetting.fromDate}
          // toDate={repoSetting.toDate}
          // gameType={repoSetting.gameType}
          // rawData={this.state.rawData}
          /> :
            <ReplayHand
              replayerScreen={'desktop'}
              loginStatus={true}
              gameNo={hand.gameNo}
              partitionDate={hand.fullDateTime}
              accountName={localStorage.getItem('accountName')}
              // playerAlias={this.props.playerReports.playerName}
              gameTypeForTitle={hand.gameType}
              // fromDate={ repoSetting.fromDate}
              // toDate= {repoSetting.toDate}
              // gameType={repoSetting.gameType} 
              // i18next={i18next}
              onClose={() => this.setState({ openHandRep: false })}
            />}
        </div> : null}

        <div className="row padding-card-hand-histroy table-header-font vertical-align-card col-border-bottom">
          <div style={{ padding: 0 }} className="col-md-7 col-xs-7 display-inline-flex-hand-history" >
            {this.state.isSelected !== undefined && <span className="MyHandshandCheckBox">
              <i onClick={() => {
                if (isSelected) {
                  this.setState({ isSelected: false })
                  this.props.unselectHand(hand)
                } else {
                  this.setState({ isSelected: true })
                  this.props.selectHand(hand)
                }
              }}
                className={`MyHandsCheckBox fa fa-check ${(this.state.isSelected) ? " MyHandsCheckBoxSelected" : ""}`} aria-hidden="true"></i>
            </span>}
            <div> {hand.pockeCard && hand.pockeCard.map((card, i) =>
              <img key={i} className="box-shadow-card card-size" src={baseUrlImage + card} alt="" />
            )}
            </div>

            <div className="card-font-size-hand-history font-style-hand-history padding-left-10">
              <span className="amount-font-style">{hand.profit >= 0 ? hand.profit > 0 ? <span className='HH_amount-color'> {(hand.gameType != "cash") ? "" : `+ ${getCurrencySymbol(this.props.hand.currency)}`}{parseFloat(hand.profit).toFixed(2).toString().replace(".00", "")} {(hand.gameType != "cash")? "BB" : ""}</span> :
                <span className='HH_amount-color-grey'> {(hand.gameType != "cash") ? "" : getCurrencySymbol(this.props.hand.currency)}0 {(hand.gameType != "cash")? "BB" : ""}</span> :
                <span className='HH_amount-color-grey'> {(hand.gameType != "cash") ? "" : `- ${getCurrencySymbol(this.props.hand.currency)}`}{parseFloat(hand.profit).toFixed(2).toString().replace("-", "").replace(".00", "")} {(hand.gameType != "cash")? "BB" : ""}</span>}
                </span><br />
              <span>{hand.time} {hand.date}</span><br />
              <span>{i18next.t("lable.Position")}: {hand.position}</span>
            </div>
          </div>
          <div className="col-md-1 col-xs-1 p-0-text-align-right pl-1">
          {!hand.cashedout? <span className='HH_SNR'>
            <img src={baseUrlImage+"/images/handReplay/cashout.png"}  width="30" height="30" hidden></img>
            </span> : <span className='HH_SNR'>
            <img src={baseUrlImage+"/images/handReplay/cashout.png"} width="30" height="30"></img>
            </span>}
          </div>
           
          <div className="col-md-1 col-xs-1 p-0-text-align-right pl-1">
            <i style={{ fontSize: "22px", marginTop: "2px" }} onClick={this.toggleStaredHand} className={" staredHandColor " + (this.state.staredHand ? "fa fa-star" : "fa fa-star-o staredHandColorUnstar")}></i>
          </div>
          <div className="col-md-2 col-xs-2 p-0-text-align-right" >
            {(hand.notes && hand.notes.length > 0) ? <span className="notecount">{hand.notes.length}</span> : null}
            <i style={{ fontSize: "22px", cursor: "pointer" }}
              data-toggle="modal"
              data-target="#EditNoteModal"
              onClick={(e) => {
                e.preventDefault()
                this.props.openNotes(hand)
              }} className={`staredHandColor edit_notePad ${(hand.notes && hand.notes.length > 0) ? "fa fa-pencil-square" : "fa fa-pencil-square-o staredHandColorUnstar"}  MyHands_mobilestarPosition`}></i>
          </div>
          <div className="col-md-2 col-xs-2 p-0-text-align-right" onClick={this.handReplayerOpen}>
            <i style={{ fontSize: "29px" }} className="hoverScale fa fa-play-circle staredHandColor staredHandColor_padding"></i>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
      selectedHandList: state.handHistory.selectedHandList,
      lang: state.header.lang
  }
}

export default connect(mapStateToProps, null)(HandCardMobile);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandCardMobile.js
 **/